export enum StaffReportTypeEnum {
  Vouchers = 'voucher-report',
  ApplicationFee = 'application-fee-report',
  IocProfit = 'ioc-profit-report',
  AuctionCreated = 'auction-created-report',
  GoogleCampaign = 'google-campaign-report',
  IocItems = 'ioc-items-report',
  TicketingRevenue = 'ticketing-revenue-report',
  DonationSliderRevenue = 'donation-slider-revenue-report',
  CampaignsClosed = 'closed-campaigns-report',
}

export interface StaffEntity {
  id: string
}

export const STAFF_LOADER = {
  createInvalidation: {
    id: 'cfInvalidation',
  },
  syncKnowledgeSources: {
    id: 'syncKnowledgeSources',
  },
}
